/* Markets & Events calendar. Reads event data emitted server-side (safely
   JSON-escaped via Liquid's `json` filter) from shop.metaobjects.zj_market_event
   and renders an interactive month calendar client-side, entirely with vanilla
   JS. No external library, no page reload on navigation/selection.
   Scoped to this page/section only; idempotent per instance. */
(function () {
  var WEEKDAY_HEADERS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var TYPE_ORDER = { market: 0, event: 1, pop_up: 2 };

  function parseISODateLocal(str) {
    if (!str) return null;
    var parts = str.split('-');
    if (parts.length !== 3) return null;
    var y = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    var d = parseInt(parts[2], 10);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
  }

  function dateKey(y, m, d) {
    return y + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
  }

  function startOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function formatLongDate(date) {
    return MONTH_NAMES[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
  }

  function formatTimeRange(start, end) {
    if (start && end) return start + ' – ' + end;
    return start || end || '';
  }

  function initInstance(section) {
    if (section.dataset.zjMarketsInit === 'true') return;
    section.dataset.zjMarketsInit = 'true';

    var dataScript = section.querySelector('[data-mkt-events]');
    var grid = section.querySelector('[data-mkt-grid]');
    var monthLabel = section.querySelector('[data-mkt-month-label]');
    var detailsEl = section.querySelector('[data-mkt-details]');
    var prevBtn = section.querySelector('[data-mkt-prev]');
    var nextBtn = section.querySelector('[data-mkt-next]');
    if (!dataScript || !grid || !monthLabel || !detailsEl) return;

    var emptyMessage = section.dataset.emptyMessage || 'No upcoming events currently scheduled.';
    var upNextLabel = section.dataset.upNextLabel || 'Up Next';

    var rawEvents;
    try {
      rawEvents = JSON.parse(dataScript.textContent || '[]');
    } catch (e) {
      rawEvents = [];
    }

    var events = rawEvents
      .filter(Boolean)
      .map(function (e) {
        var d = parseISODateLocal(e.date);
        if (!d) return null;
        return {
          id: e.id,
          title: e.title,
          type: e.type,
          dateObj: d,
          dateKey: dateKey(d.getFullYear(), d.getMonth(), d.getDate()),
          start_time: e.start_time,
          end_time: e.end_time,
          venue: e.venue,
          address: e.address,
          description: e.description
        };
      })
      .filter(Boolean)
      .sort(function (a, b) { return a.dateObj - b.dateObj; });

    var eventsByDate = {};
    events.forEach(function (e) {
      if (!eventsByDate[e.dateKey]) eventsByDate[e.dateKey] = [];
      eventsByDate[e.dateKey].push(e);
    });
    Object.keys(eventsByDate).forEach(function (key) {
      eventsByDate[key].sort(function (a, b) {
        return (TYPE_ORDER[a.type] || 0) - (TYPE_ORDER[b.type] || 0);
      });
    });

    var today = startOfDay(new Date());

    function findNearestUpcoming() {
      for (var i = 0; i < events.length; i++) {
        if (events[i].dateObj >= today) return events[i];
      }
      return null;
    }

    var nearestUpcoming = findNearestUpcoming();

    var viewYear, viewMonth;
    if (nearestUpcoming && nearestUpcoming.dateObj.getFullYear() === today.getFullYear() && nearestUpcoming.dateObj.getMonth() === today.getMonth()) {
      viewYear = today.getFullYear();
      viewMonth = today.getMonth();
    } else {
      var hasCurrentMonthUpcoming = events.some(function (e) {
        return e.dateObj >= today && e.dateObj.getFullYear() === today.getFullYear() && e.dateObj.getMonth() === today.getMonth();
      });
      if (hasCurrentMonthUpcoming) {
        viewYear = today.getFullYear();
        viewMonth = today.getMonth();
      } else if (nearestUpcoming) {
        viewYear = nearestUpcoming.dateObj.getFullYear();
        viewMonth = nearestUpcoming.dateObj.getMonth();
      } else {
        viewYear = today.getFullYear();
        viewMonth = today.getMonth();
      }
    }

    function renderDetails(event) {
      detailsEl.textContent = '';
      if (!event) {
        var p = document.createElement('p');
        p.className = 'zj-mkt__details-empty';
        p.textContent = emptyMessage;
        detailsEl.appendChild(p);
        return;
      }
      var label = document.createElement('p');
      label.className = 'zj-mkt__details-label';
      label.textContent = upNextLabel + ' — ' + formatLongDate(event.dateObj);
      detailsEl.appendChild(label);

      var title = document.createElement('h3');
      title.className = 'zj-mkt__details-title';
      title.textContent = event.title;
      detailsEl.appendChild(title);

      var timeRange = formatTimeRange(event.start_time, event.end_time);
      if (timeRange) {
        var timeEl = document.createElement('p');
        timeEl.className = 'zj-mkt__details-time';
        timeEl.textContent = timeRange;
        detailsEl.appendChild(timeEl);
      }
      if (event.venue) {
        var venueEl = document.createElement('p');
        venueEl.className = 'zj-mkt__details-venue';
        venueEl.textContent = event.venue;
        detailsEl.appendChild(venueEl);
      }
      if (event.address) {
        var addrEl = document.createElement('p');
        addrEl.className = 'zj-mkt__details-address';
        addrEl.textContent = event.address;
        detailsEl.appendChild(addrEl);
      }
      if (event.description) {
        var descEl = document.createElement('p');
        descEl.className = 'zj-mkt__details-desc';
        descEl.textContent = event.description;
        detailsEl.appendChild(descEl);
      }
    }

    function selectEvent(event) {
      renderDetails(event);
    }

    function renderMonth(year, month) {
      monthLabel.textContent = MONTH_NAMES[month].toUpperCase();
      grid.textContent = '';

      var firstWeekday = new Date(year, month, 1).getDay();
      var daysInMonth = new Date(year, month + 1, 0).getDate();
      var totalCells = Math.ceil((firstWeekday + daysInMonth) / 7) * 7;

      for (var i = 0; i < totalCells; i++) {
        var dayNum = i - firstWeekday + 1;
        var cell = document.createElement('div');
        cell.className = 'zj-mkt__cell';

        if (dayNum < 1 || dayNum > daysInMonth) {
          cell.classList.add('zj-mkt__cell--empty', 'zj-mkt__day--empty');
          cell.setAttribute('aria-hidden', 'true');
          grid.appendChild(cell);
          continue;
        }

        var numEl = document.createElement('span');
        numEl.className = 'zj-mkt__day-num';
        numEl.textContent = dayNum;
        cell.appendChild(numEl);

        var key = dateKey(year, month, dayNum);
        var dayEvents = eventsByDate[key];
        if (dayEvents && dayEvents.length) {
          var markers = document.createElement('div');
          markers.className = 'zj-mkt__markers';
          dayEvents.forEach(function (ev) {
            var marker = document.createElement('button');
            marker.type = 'button';
            marker.className = 'zj-mkt__marker';
            marker.style.background = 'var(--zj-mkt-' + (ev.type === 'pop_up' ? 'popup' : ev.type) + ')';
            marker.setAttribute('aria-label', ev.title + ', ' + formatLongDate(ev.dateObj));
            marker.addEventListener('click', function () { selectEvent(ev); });
            markers.appendChild(marker);
          });
          cell.appendChild(markers);
        }

        grid.appendChild(cell);
      }
    }

    function goToMonth(year, month) {
      viewYear = year;
      viewMonth = month;
      renderMonth(viewYear, viewMonth);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var m = viewMonth - 1, y = viewYear;
        if (m < 0) { m = 11; y -= 1; }
        goToMonth(y, m);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var m = viewMonth + 1, y = viewYear;
        if (m > 11) { m = 0; y += 1; }
        goToMonth(y, m);
      });
    }

    renderMonth(viewYear, viewMonth);
    renderDetails(nearestUpcoming);
  }

  function init() {
    var sections = document.querySelectorAll('[data-zj-markets-events]');
    sections.forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
